var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title',[_vm._v("Create Project")]),_c('v-container',[_c('ProjectForm',{attrs:{"type":"CREATE","project":_vm.project}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }